import PropTypes from 'prop-types';
import React from 'react';
import { useEffect, useState } from 'react';

import './index.scss';
import { ReactComponent as InfoIcon } from '../../../../assets/images/info.svg';
import WhiteCard from '../../../../components/WhiteCard';
import { shortMonth } from '../../../../lib/dateFormatter';
import ToolTip from '../../../ToolTip';

const ChosenSchoolDetailsDisplay = ({
  schoolName,
  universityName,
  courseName,
  periodStartDate,
  periodEndDate,
  seasonClassStartDate,
  seasonClassEndDate,
  tuitionFees,
  livingExpenses,
  restOfWorldCourse,
  selectedOffer,
}) => {
  const formattedStartDate = shortMonth(new Date(periodStartDate));
  const formattedEndDate = shortMonth(new Date(periodEndDate));

  const initialRepaymentStartDate = shortMonth(new Date(seasonClassStartDate));
  const InitialRepaymentEndDate = shortMonth(
    new Date(new Date(seasonClassEndDate).setMonth(new Date(seasonClassEndDate).getMonth() + 6)),
  );

  const firstRepaymentDate = shortMonth(
    new Date(selectedOffer.recalculation_requirements?.first_repayment_date),
  );

  const floatLivingExpenses = parseFloat(livingExpenses.replace(/,/g, ''));
  const floatTuitionfees = parseFloat(tuitionFees.replace(/,/g, ''));

  const loanAmount = (floatLivingExpenses + floatTuitionfees).toLocaleString();
  const loanAmountDescription =
    parseInt(livingExpenses) > 0 ? 'Tuition fees & living expenses' : 'Tuition fees';

  const subsequentStartDate = shortMonth(
    new Date(selectedOffer.recalculation_requirements.first_repayment_date),
  );

  const subsequentEndDate = shortMonth(
    new Date(
      new Date(selectedOffer.recalculation_requirements.first_repayment_date).setMonth(
        new Date(selectedOffer.recalculation_requirements.first_repayment_date).getMonth() +
          selectedOffer.term_in_months,
      ),
    ),
  );

  const [currentInterestRate, setCurrentInterestRate] = useState(null);
  const [showHighlight, setShowHighlight] = useState(false);

  useEffect(() => {
    if (currentInterestRate !== null && selectedOffer.interest_rate < currentInterestRate) {
      setShowHighlight(true);
      setTimeout(() => setShowHighlight(false), 1100); // Duration of the animation
    }
    setCurrentInterestRate(selectedOffer.interest_rate);
  }, [selectedOffer]);

  const interestRateColor = showHighlight ? '__highlight' : '';

  const loanAmountTooltipText = () => {
    if (!restOfWorldCourse) {
      if (parseInt(livingExpenses) > 0) {
        return 'Tuition fees and living expenses will be disbursed direct to school closer to class start';
      } else {
        return 'Tuition fees will be disbursed direct to school closer to class start';
      }
    } else {
      return 'Tuition fees will be disbursed direct to school closer to class start <br> <br> And living expense will be disbursed to your bank account in the country of study only after the classes begin';
    }
  };

  return (
    <>
      <div className="chosen-school-and-course-display__details-v3__loan-overview-title">
        Loan Overview
      </div>
      {/* {!restOfWorldCourse ? null : null} */}
      <WhiteCard className="chosen-school-and-course-display__details-v3__white-card">
        <div className="chosen-school-and-course-display__details-v3">
          <div className="chosen-school-and-course-display__details-v3__period-duration">
            Period 1: {formattedStartDate} - {formattedEndDate}
          </div>
          <div className="chosen-school-and-course-display__details-v3__small-header">
            Loan amount
            <ToolTip
              icon={<InfoIcon />}
              header="Loan amount disbursement"
              text={loanAmountTooltipText()}
            />
          </div>
          <div className="pt-1">
            USD{' '}
            <span className="w500 chosen-school-and-course-display__details-v3__large-text">
              {loanAmount}
            </span>
          </div>
          {!restOfWorldCourse ? (
            <div>{loanAmountDescription}</div>
          ) : (
            <div className="chosen-school-and-course-display__details-v3__loan-amount-grid-container">
              <div className="chosen-school-and-course-display__details-v3__grid-item pt-1">
                <div className="chosen-school-and-course-display__details-v3__grid-item__h3">
                  USD{' '}
                  <span className="w500 chosen-school-and-course-display__details-v3__large-medium-text">
                    {tuitionFees}
                  </span>
                </div>
                <div className="chosen-school-and-course-display__details-v3__grid-item__h4">
                  Tuition fees
                </div>
              </div>

              <div className="chosen-school-and-course-display__details-v3__grid-item pt-1">
                <div className="chosen-school-and-course-display__details-v3__grid-item__h3">
                  USD{' '}
                  <span className="w500 chosen-school-and-course-display__details-v3__large-medium-text">
                    {livingExpenses}
                  </span>
                </div>
                <div className="chosen-school-and-course-display__details-v3__grid-item__h4">
                  Living expenses
                </div>
              </div>
            </div>
          )}
          <div className="divider"></div>
          <div className="chosen-school-and-course-display__details-v3__grid-container">
            <div
              className={`chosen-school-and-course-display__details-v3__grid-item${interestRateColor}`}
            >
              <div className="chosen-school-and-course-display__details-v3__small-header">
                Interest rate
              </div>
              <span className="w500 chosen-school-and-course-display__details-v3__large-text">
                {selectedOffer.interest_rate}
              </span>
              <div className="chosen-school-and-course-display__details-v3__small-description">
                variable
              </div>
            </div>
            <div className="chosen-school-and-course-display__details-v3__grid-item">
              <div className="chosen-school-and-course-display__details-v3__small-header">
                Term
                <ToolTip
                  icon={<InfoIcon />}
                  header="Term"
                  text="<div>Term refers to the repayment period that begins after your study period and grace period ends</div>
                  <br>
                  <div>(Except for part-time courses)</div>"
                />
              </div>
              <span className="w500 chosen-school-and-course-display__details-v3__large-text">
                {selectedOffer.term_in_months / 12} years
              </span>
              <div className="chosen-school-and-course-display__details-v3__small-description">
                from {firstRepaymentDate}
              </div>
            </div>
            <div className="chosen-school-and-course-display__details-v3__grid-item">
              <div className="chosen-school-and-course-display__details-v3__small-header">
                Initial repayment
              </div>
              <div>
                USD{' '}
                <span className="w500 chosen-school-and-course-display__details-v3__large-text">
                  {selectedOffer.grace_payment_amount}*
                </span>
              </div>
              <div className="chosen-school-and-course-display__details-v3__smaller-description">
                {initialRepaymentStartDate} - {InitialRepaymentEndDate}
              </div>
            </div>
            <div className="chosen-school-and-course-display__details-v3__grid-item">
              <div className="chosen-school-and-course-display__details-v3__small-header">
                Subsequent repayment
              </div>
              <div>
                USD{' '}
                <span className="w500 chosen-school-and-course-display__details-v3__large-text">
                  {Math.ceil(selectedOffer.monthly_repayment)}*
                </span>
              </div>
              <div className="chosen-school-and-course-display__details-v3__smaller-description">
                {subsequentStartDate} - {subsequentEndDate}
              </div>
            </div>
          </div>
          <div className="chosen-school-and-course-display__details-v3__small-text">
            *All repayments are monthly, and you can always choose to repay more anytime without any
            penalty.
          </div>
        </div>
      </WhiteCard>
    </>
  );
};

ChosenSchoolDetailsDisplay.propTypes = {
  schoolName: PropTypes.string.isRequired,
  universityName: PropTypes.string,
  courseName: PropTypes.string.isRequired,
  periodStartDate: PropTypes.string.isRequired,
  periodEndDate: PropTypes.string.isRequired,
  seasonClassStartDate: PropTypes.string.isRequired,
  seasonClassEndDate: PropTypes.string.isRequired,
  tuitionFees: PropTypes.string.isRequired,
  livingExpenses: PropTypes.string,
  restOfWorldCourse: PropTypes.bool,
  selectedOffer: PropTypes.object,
};

export default ChosenSchoolDetailsDisplay;
